import {useEffect, useState} from 'react'
import {calculateElapsedTime, hasCompletedAt} from '../utils/elapsed-time-util'
import {SessionState} from '../types/session'

function SessionElapsedTime({
  createdAt,
  completedAt,
  updatedAt,
  state,
}: {
  createdAt: Date | string
  completedAt?: Date | string
  updatedAt?: Date | string
  state: SessionState
}) {
  const effectiveCompletedAt =
    state === SessionState.WaitingForUser
      ? (updatedAt ?? (hasCompletedAt(completedAt) ? completedAt : undefined))
      : completedAt

  // Use useEffect to update the elapsed time when props change
  const [elapsedTime, setElapsedTime] = useState<string>(() => calculateElapsedTime(createdAt, effectiveCompletedAt))

  // Calculate initial elapsed time and update when props change
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setElapsedTime(calculateElapsedTime(createdAt, effectiveCompletedAt))

    if (state === SessionState.InProgress || state === SessionState.Queued) {
      const interval = setInterval(() => {
        setElapsedTime(calculateElapsedTime(createdAt, effectiveCompletedAt))
      }, 500)
      return () => clearInterval(interval)
    }
  }, [createdAt, effectiveCompletedAt, state])
  return (
    <time aria-live="off" className="text-tabular-nums">
      {elapsedTime}
    </time>
  )
}

export default SessionElapsedTime
